import { Molecule } from './molecule.model';

export class Reagent extends Molecule {
  type: string;
}
